/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { deserializeFilter } from 'cio/utils/conditions/deserialize/attribute';
import { SerializedLegacyAttributeFilter } from 'cio/types/conditions/legacy-filter';
import CampaignModel from 'cio/models/campaign';
import { computed } from '@ember/object';
import { DataSourceLabelVariant } from 'cio/utils/data-source-label';
import { ConditionViewerBackgroundVariant } from 'cio/utils/condition-viewer';

interface CioConditionLabelItemEventAttributeArgs {
  condition: SerializedLegacyAttributeFilter;
  campaign?: CampaignModel;
  labelVariant?: DataSourceLabelVariant;
  labelTruncate?: boolean;
  tagName: string;
  backgroundVariant?: ConditionViewerBackgroundVariant;
}

export default class CioConditionLabelItemEventAttribute extends Component<CioConditionLabelItemEventAttributeArgs> {
  @computed('args.condition.{name,operator,value,value2,comparison_operator}')
  get conditionModel() {
    return deserializeFilter(this.args.condition);
  }
}
